var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-content"},[_c('div',{staticClass:"empty-icon"}),_c('div',{staticClass:"empty-text"},[_vm._v("\n        Постройте план развития\n    ")]),_c('router-link',{staticClass:"blue-button empty-button",attrs:{"to":{ name: 'profession-categories' }}},[_vm._v("\n        Добавить обучение\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }